import $ from 'jquery'
import { Util } from 'bootstrap'

const DATA_KEY = 'opp.collapsible-input'
const EVENT_KEY = `.${DATA_KEY}`
const DATA_API_KEY = '.data-api'

const Selector = {
  DATA_TOGGLE: '[data-toggle="collapse"]',
  INPUT: '.collapsible-input',
  SHOW: '.show'
}

const Event = {
  LOAD_DATA_API: `load${EVENT_KEY}${DATA_API_KEY}`
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */

$(window).on(Event.LOAD_DATA_API, () => {
  // Find each hidden collapse target and click the trigger to show it via the
  // collapse data-api if it contains a "collapse-input" having a truthy value.
  $(Selector.DATA_TOGGLE).each(function () {
    const element = this
    const selector = Util.getSelectorFromElement(element)
    // N.B. return to terminate loop when false
    return $(selector).not(Selector.SHOW).each(function () {
      // N.B. return to terminate loop when false
      return $(this).find(Selector.INPUT).each(function () {
        if (this.value) {
          element.click() // toggle bs.collapse via data-api
          return false // N.B. terminate loop
        }
      })
    })
  })
})
